// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"6b155aa3","182":"cc9e3ffb","307":"27cbd74d","650":"bd6384be","717":"bd6384be","753":"bd6384be"}[chunkId] + ".chunk.css";
};